import React from "react";
import { EmptyState } from "../EmptyState";

export function DepartmentBarChart({ data, onBarClick, activeDept }) {
  if (!data.length) return <EmptyState />;
  const max = Math.max(...data.map((d) => d.count), 1);
  return (
    <div className="flex flex-col gap-2.5">
      {data.map((d) => {
        const isActive = activeDept === d.label;
        const dim = activeDept !== "ALL" && !isActive;
        return (
          <button
            key={d.label}
            onClick={() => onBarClick(d.label)}
            className="flex items-center gap-3 group text-left"
          >
            <span
              className={`text-xs w-[78px] shrink-0 truncate ${
                isActive ? "font-bold text-slate-900" : "font-medium text-slate-600"
              }`}
            >
              {d.label}
            </span>
            <span className="flex-1 h-2.5 rounded-full bg-slate-100 overflow-hidden">
              <span
                className="block h-full rounded-full transition-all duration-300"
                style={{
                  width: `${(d.count / max) * 100}%`,
                  background: isActive ? "#1D4ED8" : dim ? "#BFDBFE" : "#3B82F6",
                }}
              />
            </span>
            <span
              className={`text-xs w-7 text-right shrink-0 ${
                isActive ? "font-bold text-slate-900" : "font-semibold text-slate-600"
              }`}
            >
              {d.count}
            </span>
          </button>
        );
      })}
    </div>
  );
}